import service from './fetchInterceptor';

export const portalRegister = (data) =>
  service.post('/auth/portal-register', data);

export const getProfile = () =>
  service.get('/profile');

export const updateProfile = (data) =>
  service.patch('/profile', data);

export const getNotaryDocuments = () =>
  service.get('/notary-documents');

export const uploadNotaryDocument = (formData) =>
  service.post('/notary-documents', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const updateNotaryDocument = (id, data) =>
  service.patch(`/notary-documents/${id}`, data);

export const deleteNotaryDocument = (id) =>
  service.delete(`/notary-documents/${id}`);

// Announcements
export const getAnnouncements = () =>
  service.get('/announcements');

export const getAllAnnouncements = () =>
  service.get('/announcements/all');

export const createAnnouncement = (data) =>
  service.post('/announcements', data);

export const updateAnnouncement = (id, data) =>
  service.patch(`/announcements/${id}`, data);

export const deleteAnnouncement = (id) =>
  service.delete(`/announcements/${id}`);

// Repertory Index
export const searchRepertoryIndex = (params) =>
  service.get('/repertory-index', { params });

export const getRepertoryYears = () =>
  service.get('/repertory-index/years');

export const getRepertoryActTypes = () =>
  service.get('/repertory-index/act-types');

export const createRepertoryEntry = (data) =>
  service.post('/repertory-index', data);

export const updateRepertoryEntry = (id, data) =>
  service.patch(`/repertory-index/${id}`, data);

export const deleteRepertoryEntry = (id) =>
  service.delete(`/repertory-index/${id}`);

export const importRepertoryIndex = (entries) =>
  service.post('/repertory-index/import', { entries });

export const deleteRepertoryIndexByYear = (year) =>
  service.delete(`/repertory-index/year/${year}`);

// Portal Activity
export const logPortalActivity = (action, details) =>
  service.post('/portal-activity', { action, details }).catch(() => {});

export const getPortalActivity = (params) =>
  service.get('/portal-activity', { params });

export const getPortalActivityGrouped = (params) =>
  service.get('/portal-activity/grouped', { params });

export const getPortalActivityStats = () =>
  service.get('/portal-activity/stats');

export const getPortalActivityDailyStats = (days) =>
  service.get('/portal-activity/daily-stats', { params: { days } });

export const exportPortalActivity = () =>
  service.get('/portal-activity/export', { responseType: 'blob' });

export const exportRepertoryIndex = (year) =>
  service.get('/repertory-index/export', { params: year ? { year } : {}, responseType: 'blob' });

export const getRepertoryGaps = (year) =>
  service.get('/repertory-index/gaps', { params: { year } });
